import { React, useRef } from 'react';
import emailjs from 'emailjs-com';
import SubHeading from '../SubHeading/SubHeading';
import './Newsletter.css';

const Newsletter = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_5vp4frj', 'template_h1r6y4v', form.current, 'XB0KYlKTX5aHlfGjW');
    e.target.reset();
  };
  const Subm = () => {
    alert('Message Sent Sucessfully');
  };
  return (

    <div className="app__newsletter">
      <div className="app__newsletter-heading">
        <SubHeading title="ContactUs" />
        <h1 className="headtext__cormorant">Book Your Apointment</h1>
        {/* <p className="p__opensans">And never miss latest Updates!</p> */}
      </div>
      <form ref={form} onSubmit={sendEmail}>
        <div className="app__newsletter-input flex__center">
          <input type="text" placeholder="Enter your name" />
          <input type="email" placeholder="Enter your email address" />
          <input type="text" placeholder="Enter your message" />
          <button type="button" style={{ marginTop: '25px' }} className="custom__button" onClick={Subm}>
            Appoint
          </button>
        </div>
      </form>
    </div>
  );
};
export default Newsletter;
